import { extractBranchFromUrl } from '../utils/url/extractBranchFromUrl'; // Adjust the import path as necessary

const originUrl = window.location.origin;

const appUrl = '';

const branchUrl = extractBranchFromUrl();

const pageUrl = window.location.pathname
    .replace(appUrl, '')
    // eslint-disable-next-line no-extra-boolean-cast
    .replace(!!branchUrl ? `/${branchUrl}` : '', '');

const buyingRegEx = new RegExp(
    /^https?:\/\/buying(-dev|-test|)\.bestseller\.com(?:[/:?]|$)/i
);

const ambasRegEx = new RegExp(
    /^https?:\/\/ambassador\.buying01(-dev|-test|-prod)\.k8s\.bestcorp\.net(\/|$)/i
);

const backendUrl =
    buyingRegEx.test(originUrl) || ambasRegEx.test(originUrl)
        ? originUrl
        : 'https://ambassador.buying01-dev.k8s.bestcorp.net';

const generate = {
    masterUrl: (page = '/'): string => `${originUrl}${appUrl}${page}`,
    fullUrl: (page = '/'): string => `${originUrl}${appUrl}${branchUrl}${page}`,
};

export { appUrl, backendUrl, branchUrl, generate, originUrl, pageUrl };
